import React from 'react';

export default function GuidePage() {
  return (
    <div className="max-w-4xl mx-auto px-4 py-12">
      <h1 className="text-2xl md:text-3xl font-bold text-white mb-4">Guideline</h1>
      <p className="text-gray-300">
        Learn how to use TadReamk Eye effectively. (Coming soon)
      </p>
    </div>
  );
}


